import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Search } from "@/models";

const getTaxonomy = (context, params) =>
  restApiDispatcher(context, {
    resource: Search,
    storeKey: params.storeKey,
    loadingKey: params.loadingKey,
    action: "getTaxonomyItems",
    commitType: "taxonomy",
    params
  });

  const getSortedTaxonomy = (context, params) =>
  restApiDispatcher(context, {
    resource: Search,
    storeKey: params.storeKey,
    loadingKey: params.loadingKey,
    action: "getSortedTaxonomyItems",
    commitType: "taxonomy",
    params
  });

export default {
  getTaxonomy,
  getSortedTaxonomy
};
